import { styled } from '@mui/material/styles';
import { Box, Stack, Container, Typography } from '@mui/material';

import { Page, Image } from '../../../shared/components/base';
import { LoginForm } from './components';

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

function Login() {
  return (
    <Page title="Login">
      <RootStyle>
        <Container maxWidth="sm">
          <ContentStyle>
            <Box
              sx={{
                alignSelf: 'center',
              }}
            >
              <Image
                visibleByDefault
                disabledEffect
                src="/assets/logo.png"
                alt="login"
                sx={{
                  width: 300,
                }}
              />
            </Box>

            <Stack
              direction="row"
              alignItems="center"
              sx={{
                mb: 5,
              }}
            >
              <Box
                sx={{
                  flexGrow: 1,
                }}
              >
                <Typography
                  variant="h4"
                  gutterBottom
                  sx={{
                    textAlign: 'center',
                  }}
                >
                  Sign in to Hula
                </Typography>

                <Typography
                  sx={{
                    color: 'text.secondary',
                    textAlign: 'center',
                  }}
                >
                  Enter your details below.
                </Typography>
              </Box>
            </Stack>

            <LoginForm />
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}

export default Login;
